import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import api from "@/lib/api";

const VARIANT_ACCENTS = { kl: "#00E676", dr: "#2997FF", golden_raja: "#FFD700" };
const DRAW_ORDER = [
  "GOLDEN RAJA 11AM",
  "GOLDEN RAJA 12PM",
  "DEAR 1PM",
  "KL 3PM",
  "GOLDEN RAJA 5PM",
  "DEAR 6PM",
  "GOLDEN RAJA 7PM",
  "DEAR 8PM",
];

export default function ResultsTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const load = () => {
      api
        .get("/results/latest")
        .then((res) => {
          const istToday = new Date(Date.now() + 19800000).toISOString().slice(0, 10);
          const mapped = res.data
            .filter((r) => r.date === istToday)
            .map((r) => ({
              label: r.variant === "golden_raja" ? `GOLDEN RAJA ${r.time}` : r.category_name.toUpperCase(),
              result: r.result,
              accent: VARIANT_ACCENTS[r.variant] || "#FFD700",
            }))
            .sort((a, b) => DRAW_ORDER.indexOf(a.label) - DRAW_ORDER.indexOf(b.label));
          setItems(mapped);
        })
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  if (!items.length) return null;

  return (
    <section data-testid="results-ticker" className="overflow-hidden border-y border-[#FFD700]/25 bg-[#0A0800]">
      <div className="flex items-stretch">
        <div className="flex shrink-0 items-center gap-2 border-r border-[#FFD700]/25 bg-[#FFD700] px-4 py-3 md:px-6">
          <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-black" />
          <span className="whitespace-nowrap font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-black">
            Live Results
          </span>
        </div>
        <Marquee speed={40} gradient={false} pauseOnHover className="py-3">
          {[...items, ...items].map((item, i) => (
            <span key={i} data-testid={i < items.length ? `ticker-item-${item.label.replace(/\s+/g, "-")}` : undefined} className="mx-6 flex items-center gap-3 whitespace-nowrap">
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#A1A1A6]">{item.label}</span>
              <span
                className="font-mono text-lg font-black tracking-[0.12em]"
                style={{ color: item.accent, textShadow: `0 0 18px ${item.accent}88` }}
              >
                {item.result}
              </span>
              <span className="text-[#FFD700]/40">•</span>
            </span>
          ))}
        </Marquee>
        <div
          data-testid="ticker-date-label"
          className="flex shrink-0 items-center border-l border-[#FFD700]/25 px-4 py-3 md:px-6"
        >
          <span className="whitespace-nowrap font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-[#FFD700]">
            {new Date(Date.now() + 19800000).toLocaleDateString("en-GB", { weekday: "short", day: "2-digit", month: "short", year: "numeric", timeZone: "UTC" })}
          </span>
        </div>
      </div>
    </section>
  );
}
